import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import ProdUnitLinkType from './ProdUnitLinkType'
import { shallowEqual, useSelector } from 'react-redux'
import { groupBy, orderBy } from 'lodash'
import { PRODUCTION_UNIT_LINK_TYPES } from 'productionUnit/constants/ProductionUnitConstants'
import { convertSvgToBase64, getSiteTypeMarker } from 'utils/SvgUtil'
import DtoProductionUnitLink from 'productionUnit/dto/DroProductionUnitLink'
import { getSandreLabel } from 'utils/StringUtil'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import { parsePonderation } from '../../station/components/associatedStation/StationLinkOptionsUtils'

const ProductionUnitLinks = ({
    readMode = false,
    stateLinks = [],
    dispatchStateLinks = [],
}) => {
    const {
        prodUnitLinks,
        sandreCodes,
    } = useSelector(store => ({
        prodUnitLinks: store.ProductionUnitReducer.prodUnitLinks,
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const data = useMemo(() => {
        const updatedDataLinks = [
            ...prodUnitLinks.filter((link) => !stateLinks.deletedLinks.some(dl => dl.siteCode === link.siteCode && dl.siteType === link.siteType && dl.linkType === link.linkType)),
            ...stateLinks.addedLinks,
        ].map(al => stateLinks.updatedLinks.find(lk => al.siteCode === lk.siteCode && al.siteType === lk.siteType && al.siteType === lk.siteType) || al)
        return groupBy(orderBy(updatedDataLinks.map(d => {
            const svg = getSiteTypeMarker(d.siteType)
            return {
                ...d,
                nullLabel: svg && (<img src={convertSvgToBase64(svg).replace('image://', '')}
                    style={{ maxHeight: '20px' }}
                />),
                statusLabel: getSandreLabel(sandreCodes, SANDRE.LIEN_STATUT, d.status),
                ponderation: parsePonderation(d.options),
            }
        }), 'siteType'), 'linkType')
    }, [prodUnitLinks, stateLinks])

    const resourcesData = useMemo(() => {
        return data[PRODUCTION_UNIT_LINK_TYPES.RESOURCES] || []
    }, [data])

    const monitoringData = useMemo(() => {
        return data[PRODUCTION_UNIT_LINK_TYPES.MONITORING] || []
    }, [data])

    const productionData = useMemo(() => {
        return data[PRODUCTION_UNIT_LINK_TYPES.PRODUCTION] || []
    }, [data])

    const jobData = useMemo(() => {
        return data[PRODUCTION_UNIT_LINK_TYPES.JOB] || []
    }, [data])

    const distributionData = useMemo(() => {
        return data[PRODUCTION_UNIT_LINK_TYPES.DISTRIBUTION] || []
    }, [data])

    const udiData = useMemo(() => {
        return data[PRODUCTION_UNIT_LINK_TYPES.UDI] || []
    }, [data])

    const params = {
        readMode,
        dispatchStateLinks,
    }

    return (
        <>
            <Grid size={12}>
                <ProdUnitLinkType data={resourcesData} linkType={PRODUCTION_UNIT_LINK_TYPES.RESOURCES} {...params} />
            </Grid>
            <Grid size={12}>
                <ProdUnitLinkType data={monitoringData} linkType={PRODUCTION_UNIT_LINK_TYPES.MONITORING} {...params} />
            </Grid>
            <Grid size={12}>
                <ProdUnitLinkType data={productionData} linkType={PRODUCTION_UNIT_LINK_TYPES.PRODUCTION} {...params} />
            </Grid>
            <Grid size={12}>
                <ProdUnitLinkType data={jobData} linkType={PRODUCTION_UNIT_LINK_TYPES.JOB} {...params} />
            </Grid>
            <Grid size={12}>
                <ProdUnitLinkType data={distributionData} linkType={PRODUCTION_UNIT_LINK_TYPES.DISTRIBUTION} {...params} />
            </Grid>
            <Grid size={12}>
                <ProdUnitLinkType data={udiData} linkType={PRODUCTION_UNIT_LINK_TYPES.UDI} {...params} />
            </Grid>
        </>
    )
}

ProductionUnitLinks.propTypes = {
    readMode: PropTypes.bool,
    stateLinks: PropTypes.arrayOf(PropTypes.instanceOf(DtoProductionUnitLink)),
    dispatchStateLinks: PropTypes.func,
}

export default ProductionUnitLinks